<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <h6>{{ $t("subcourses.subcourseDetails") }}</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center justify-content-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 subcourse-title"
              >
                {{ $t("subcourses.subcourseTitle") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                {{ $t("teachers.detail.numberOfCandidate") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                {{ $t("subcourses.coursePrice") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                {{ $t("teachers.detail.subcourseStartDate") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                {{ $t("teachers.pastMonths") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder text-center opacity-7 ps-2"
              >
                {{ $t("teachers.detail.currentSubcourseProgress") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder text-center opacity-7 ps-2"
              >
                {{ $t("teachers.detail.subcourseDuration") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder text-center opacity-7 ps-2"
              ></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="subcourse-title">
                {{ subcourse.title }}
              </td>
              <td>
                <span class="text-xs font-weight-bold mb-0">
                  {{ subcourse.kids_per_subcourse }}
                </span>
              </td>
              <td>
                <span class="text-xs font-weight-bold mb-0">
                  {{ subcourse.price }} {{ $t("global.currency") }}
                </span>
              </td>
              <td>
                <span class="text-xs font-weight-bold">{{
                  subcourse.start_date
                }}</span>
              </td>
              <td>
                <span class="text-xs font-weight-bold"
                  >{{ subcourse.number_of_finished_months }}.</span
                >
              </td>
              <td class="align-middle text-center">
                <div class="d-flex align-items-center justify-content-center">
                  <span class="me-2 text-xs font-weight-bold"
                    >{{ subcourse.course_progress }}%</span
                  >
                  <div>
                    <soft-progress
                      color="info"
                      variant="gradient"
                      :percentage="subcourse.course_progress"
                    />
                  </div>
                </div>
              </td>
              <td class="align-middle ps-2">
                <span class="me-2 text-xs font-weight-bold">
                  {{ subcourse.number_of_months }}
                  {{ this.formatMonthsTitle(subcourse.number_of_months) }}
                </span>
              </td>
              <td>
                <soft-badge
                  v-if="!subcourse.deleted_at"
                  color="dark"
                  variant="gradient"
                  size="sm"
                  @click="goToKids(subcourse.id)"
                  class="cursor-pointer"
                >
                  {{ $t("kids.kids") }}
                </soft-badge>
              </td>
              <!-- <td class="px-4">
                <a
                  class="btn btn-link text-dark px-3 mb-0"
                  href="javascript:;"
                  @click="editSubcourse(subcourse)"
                >
                  <i
                    class="fas fa-pencil-alt text-dark me-2"
                    aria-hidden="true"
                  ></i
                  >{{ $t("global.edit") }}
                </a>
              </td> -->
            </tr>
          </tbody>
        </table>
        <div class="m-4">
          <soft-badge
            color="warning"
            variant="gradient"
            size="sm"
            @click="$emit('close')"
            class="cursor-pointer"
          >
            {{ $t("global.close") }}
          </soft-badge>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SoftProgress from "@/components/SoftProgress";
import SoftBadge from "@/components/SoftBadge.vue";

export default {
  name: "subcourse-details",
  components: {
    SoftProgress,
    SoftBadge,
  },
  props: {
    subcourse: {
      type: Object,
      required: true,
      default: () => {},
    },
    lastSeason: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    goToKids(subcourseId) {
      this.$router.push({
        name: "Kids",
        params: { id: subcourseId, lastSeason: this.lastSeason },
      });
    },
    editSubcourse(item) {
      console.log(item.title);
    },
    formatMonthsTitle(numberOfMonths) {
      return numberOfMonths > 4
        ? this.$t("teachers.detail.months")
        : this.$t("teachers.detail.month");
    },
  },
};
</script>

<style scoped>
.container {
  display: inline-flex;
  justify-content: flex-start;
  position: relative;
}

tr,
td {
  text-align: center;
  vertical-align: middle;
}
.subcourse-title {
  padding-left: 30px;
  text-align: left;
}
</style>
